const langKey = "lang-key";
 
//存储语言
export const setLang = lang => {
  return localStorage.setItem(langKey, lang);
};
//获取语言
export const getLang = () => {
  return localStorage.getItem(langKey);
};